import { render, staticRenderFns } from "./settingsPanel.vue?vue&type=template&id=6b553b1e&lang=pug&"
import script from "./settingsPanel.vue?vue&type=script&lang=js&"
export * from "./settingsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports